import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { WinkingPersonIcon } from '@/assets';
import { ClosableCard } from '@/features/start/components/components/ClosableCard';
import { useTutorial } from '@/features/tutorial/providers/useTutorial';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

export const FirstStepsCard: FC = () => {
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'components'
  });
  const { present: presentTutorial, hideCard: hideTutorial } = useTutorial();

  return (
    <ClosableCard
      title={t('firstSteps.title')}
      testId="card-first-steps"
      text={t('firstSteps.text')}
      icon={WinkingPersonIcon}
      hasMore
      onMore={presentTutorial}
      onClose={hideTutorial}
    />
  );
};

FirstStepsCard.displayName = 'FirstStepsCard';
